import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import LazyLoad from "vanilla-lazyload";

gsap.registerPlugin(ScrollTrigger);

const revealElements = gsap.utils.toArray(".reveal-up");
revealElements.forEach((el) => {
  gsap.from(el, {
    scrollTrigger: {
      trigger: el,
      start: "top bottom+=100",
    },
    y: 100,
    duration: 0.75,
    opacity: 0,
    start: "top top",
  });
});

// Lazy load images
const lazyImg = new LazyLoad({
  // elements_selector: ".lazy-img",
  cancel_on_exit: false,
});

//blur
// $(window).on('scroll', function () {
//     var pixs = $(document).scrollTop()
//     pixs = pixs / 25;
//     $(".blurimage").css({"-webkit-filter": "blur("+pixs+"px)","filter": "blur("+pixs+"px)" })
// });
